<div kalDialogHeader>
    <h2 class="gup-O-titrage__title">
        Paramétrer les catégories de documents
    </h2>
</div>

<div kalDialogContent [kalLoading]="loading">

    <kal-table #table
               [columns]="columns"
               [dataSource]="categoryList"
               class="no-action"
               virtual
               virtualItemSize="35"
               virtualViewPortHeight="calc(100vh - 550px)"
               [virtualRowClassFunction]="virtualRowClassFunction"
               actionable>

        <tr kal-header-row *kalHeaderRowDef></tr>

        <td *kalBodyCell="'CodeControl' let element">
            <kal-form-field class="without-label">
                <kal-input [formControl]="element.CodeControl"></kal-input>
            </kal-form-field>
        </td>

        <td *kalBodyCell="'LibelleControl' let element">
            <kal-form-field class="without-label">
                <kal-input [formControl]="element.LibelleControl"></kal-input>
            </kal-form-field>
        </td>

        <ng-container [kalColumn]="table.actionColumnName">
            <td *kalBodyCell="let element; let index=index">
                <div>

                    <kal-button (click)="stopPropagation($event)"
                                [kalMenuTriggerFor]="actionsMenu"
                                kalTheme="tertiary">
                        <kal-icon>more_horiz</kal-icon>
                    </kal-button>

                    <kal-menu #actionsMenu>
                        <kal-option (selectionChange)="deleteCategory(index)">
                            Supprimer
                        </kal-option>
                    </kal-menu>

                </div>
            </td>
        </ng-container>

    </kal-table>

    <a (click)="addCategory()" class="gup-C-moreInfos gup-O-link  gup-U-margin-top--normal">
        <kal-icon>add</kal-icon>
        <span>Ajouter une catégorie</span>
    </a>

</div>

<div kalDialogFooter>
    <div class="gup-C-validationArea gup-O-list">
        <div class="gup-O-list__item">
            <kal-button kalTheme="primary"
                        [disabled]="shouldDisableSaveButton"
                        (click)="save()">
                Enregistrer
            </kal-button>
        </div>
        <div class="gup-O-list__item">
            <kal-button kalTheme="secondary"
                        (click)="cancel()">
                Annuler
            </kal-button>
        </div>
    </div>
</div>
